<div class="container-fluid">
    <div class="row">
        <div class="col-md-3">
            <a routerLink="/naac/ssr" *ngIf="showSideMenu"> <i class="fas fa-long-arrow-alt-left"></i> Go Back</a>
            <nav id="secondary-navigation" *ngIf="showSideMenu">
                <!-- Header -->
                <header class="header">
                    <h5>CRITERIA 4</h5>
                </header>
                <!-- /Header -->
                <ul>
                    <li routerLinkActive="active">
                        <a  routerLink="/naac/ssr/criteria4/4-1" (click)="checkRoute()">4.1</a>
                    </li>
                    <li routerLinkActive="active">
                        <a routerLink="/naac/ssr/criteria4/4-2" (click)="checkRoute()">4.2</a>
                    </li>
                    <li routerLinkActive="active">
                        <a routerLink="/naac/ssr/criteria4/4-3" (click)="checkRoute()">4.3</a>
                    </li>
                    <li routerLinkActive="active">
                        <a routerLink="/naac/ssr/criteria4/4-4" (click)="checkRoute()">4.4</a>
                    </li>
                </ul>
            </nav>
        </div>
        <div [ngClass]="fullWidth ? 'col-md-12' : 'col-md-9'">
            <h4 class="text-center">Infrastructure & Learning Resources</h4>
            <router-outlet></router-outlet>
        </div>
    </div>
</div>